module.exports = __webpack_public_path__ + "static/06-2916f480cdc4df124a25f11e3601d15d.jpg";